import React from 'react';
import { number } from 'prop-types';

import '../styles/ChildCategoriesSkeleton.css';

function ChildCategoriesSkeleton({ childCollectionsCount }) {
    return (
        <div
            className={'child-categories-skeleton'}
            style={{ marginBottom: '4em' }}
        >
            <div
                className={'skeleton'}
                style={{
                    height: '45px',
                    maxWidth: '200px',
                }}
            />
            <div
                className={'child-categories-skeleton-content'}
            >
                {new Array(childCollectionsCount).fill(0).map((_, i) => (
                    <div
                        key={i}
                        className={'skeleton'} />
                ))}
            </div>
        </div>
    );
}

ChildCategoriesSkeleton.propTypes = {
    childCollectionsCount: number,
};

export default ChildCategoriesSkeleton;